<div class="row">
  <div class="col-12">
    <div class="page-title-box d-sm-flex align-items-center justify-content-between">
      <h4 class="mb-sm-0">Dashboard</h4>
      <div class="page-title-right">
        <ol class="breadcrumb m-0">
          <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
          <li class="breadcrumb-item active">Dashboard</li>
        </ol>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="h-100">
      <div class="row mb-3 pb-1">
        <div class="col-12">
          <div class="d-flex align-items-lg-center flex-lg-row flex-column">
            <div class="flex-grow-1">
              <h4 class="fs-16 mb-1">Good Morning, {{ username }}!</h4>
              <p class="text-muted mb-0">Welcome to E-Commerce Admin Portal</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
